import type { ComponentProps, FC } from 'react';

import { LoadingSpinner } from '@catalyze/ui';

import { Container } from './styled';

type ILoadingOverlayProps = ComponentProps<typeof Container> & {
    shown?: boolean;
};

export const LoadingOverlay: FC<ILoadingOverlayProps> = (props) => {
    return (
        <Container {...props}>
            <LoadingSpinner />
        </Container>
    );
};

LoadingOverlay.defaultProps = {
    shown: false,
};
